import { render, staticRenderFns } from "./listRecentNews.vue?vue&type=template&id=bd073646&"
import script from "./listRecentNews.vue?vue&type=script&lang=js&"
export * from "./listRecentNews.vue?vue&type=script&lang=js&"
import style0 from "./listRecentNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports